export const CURRENT_TERMS_VERSION = process.env.NEXT_PUBLIC_TERMS_VERSION;